import {FC, useEffect} from "react";
import api from "api";
import {IAccountant} from "api/types";
import {useQuery} from "@tanstack/react-query";
import {useParams, useNavigate} from "react-router";
import LoadedAccountantProfilePage from "./Loaded";

const AccountantProfilePage: FC = () => {
  const id = useParams().id;
  const navigate = useNavigate();

  const {data: user, isSuccess} = useQuery<IAccountant | null>({
    queryKey: ["accountant-profile", id],
    queryFn: () => api.getProfile(id!) as Promise<IAccountant | null>,
    enabled: !!id,
  });

  useEffect(() => {
    if (!id) navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (isSuccess && !user) navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, user]);

  if (user) return <LoadedAccountantProfilePage user={user} />;

  return (
    <div className="h-full overflow-y-auto overflow-x-hidden bg-brand-cream">
      <div className="px-8 py-7 flex flex-col gap-5">
        <div className="h-8 w-48 rounded-xl bg-slate-200 animate-pulse" />
        <div className="rounded-2xl border border-brand-border bg-white h-14 animate-pulse" />
        <div className="rounded-2xl border border-brand-border bg-white h-52 animate-pulse" />
        <div className="rounded-2xl border border-brand-border bg-white h-12 animate-pulse" />
        <div className="rounded-2xl border border-brand-border bg-white h-64 animate-pulse" />
      </div>
    </div>
  );
};

export default AccountantProfilePage;
